'use strict';

var NO_WINDOW_WARNING = 'There is no window object, please provide a custom data layer';

module.exports = {
  NO_WINDOW_WARNING: NO_WINDOW_WARNING
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-gtm/lib/messages.js
// module id = 331
// module chunks = 0